import { Link } from "react-router-dom";

interface SectionHeadingProps {
  kicker?: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({
  kicker,
  title,
  description,
  linkTo,
  linkLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {kicker && (
          <span className="mb-2 flex items-center gap-1.5 font-label text-[11px] uppercase tracking-[0.2em] text-primary-600">
            <i className="ri-heart-3-fill text-xs" />
            {kicker}
          </span>
        )}
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {description && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{description}</p>}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
        >
          {linkLabel}
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      )}
    </div>
  );
}